<template>
  <div>
    <!-- 发票列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>发票列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <div class="conentTitle">
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-select v-model="value" clearable placeholder="分销商">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-button type="primary">查询</el-button>
      </div>

      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="name" label="开票日期"></el-table-column>
          <el-table-column prop="address" label="发票代码/发票号码"></el-table-column>
          <el-table-column prop="address" label="已开票金额"></el-table-column>
          <el-table-column prop="address" label="状态"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="seeInfoFn(scope.row,11)">查看详情</el-button>
              <el-button type="text" @click="seeInfoFn(scope.row,22)">更正发票信息</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 查看详情开始 -->
    <orderDialog v-if="seeinfovisible" ref="seeinfoDialog"></orderDialog>
    <!-- 查看详情结束 -->
  </div>
</template>

<script>
import orderDialog from "./dialog/orderDialog.vue";
import {getScenicCloseList} from '@/request/scenic.js'
export default {
  components: {
    orderDialog
  },
  data() {
    return {
      seeinfovisible: false, // 查看详情
      tableData: [
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:10
      }
    };
  },
  created(){
    this.getList()
  },
  methods: {
    // 获取发票列表
    getList(){
      getScenicCloseList(this.data).then(res=>{
        console.log(res)
      })
    },
    // 查看详情
    seeInfoFn(row,num) {
      this.seeinfovisible = true;
      this.$nextTick(() => {
        this.$refs.seeinfoDialog.seeInfo(row,num);
      });
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-card__body {
  padding: 0 20px;
}
.conentBox {
  margin-top: 17px;
  .sel {
    margin: 0 20px;
  }
  .conentTitle {
    margin: 20px 0;
    display: flex;

    .el-select {
      width: 260px;
      margin-right: 20px;
    }
    .el-date-editor {
      width: 400px;
      margin: 0 20px;
    }
    .el-button {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
    .btnMar {
      margin: 0 10px 0 20px;
    }
  }
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>